import { PureComponent } from 'react';
import { Field } from 'redux-form';
import parseValue from './parseValue';
import formatValue from './formatValue';
import RangeSliderControl from '../Control';

const getFieldProps = (props) => {
  const { emptyValue } = props;

  if (emptyValue !== undefined) {
    props = {
      ...props,
      parse: (value) => parseValue(value, emptyValue),
      format: (value) => formatValue(value, emptyValue),
    };
  }

  return props;
};

export default class RangeSliderField extends PureComponent {
  render() {
    return (
      <Field {...getFieldProps(this.props)} component={RangeSliderControl} />
    );
  }
}
